module.exports = __webpack_public_path__ + "img/2.afddc29e.png";